<template>
  <li>
    <div
      :class="[
        selectedPath === parentPath + 'box' ? 'focused' : '',
        errorPath.includes(parentPath + 'box') ? 'has-error' : '',
      ]"
      @click="selectNode(box, parentPath + 'box')"
      @mouseenter="isHover = true"
      @mouseleave="isHover = false"
    >
      <span class="node-icon">
        <q-icon
          size="xs"
          :name="showChild ? 'arrow_drop_down' : 'arrow_right'"
          @click="showChild = !showChild"
        />
      </span>
      <span>box [{{ box.layout }}]</span>
    </div>
    <ul :style="!showChild ? 'display: none;' : ''">
      <template v-for="(item, index) in box.contents" :key="index">
        <FlexMessageTreeNodes
          :component="item"
          :type="item.type"
          :parentPath="parentPath + 'box-' + index + '.'"
          :selectedNode="selectedNode"
          :selectedPath="selectedPath"
          :errorPath="errorPath"
          @onSelectNode="selectNode"
          @onHoverNode="(val) => $emit('onHoverNode', val)"
        />
      </template>
    </ul>
  </li>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import {
  IFlexMessageBox,
  IFlexMessageBubble,
  IFlexMessageButton,
  IFlexMessageCarousel,
  IFlexMessageFiller,
  IFlexMessageIcon,
  IFlexMessageImage,
  IFlexMessageSeparator,
  IFlexMessageSpan,
  IFlexMessageText,
  IFlexMessageVideo,
} from '@/utils/types'
import FlexMessageTreeNodes from '@/components/common/flex-message/FlexMessageTreeNodes.vue'

@Options({
  components: { FlexMessageTreeNodes },
  directives: { maska },
  emits: ['onSelectNode', 'onHoverNode'],
})
export default class Box extends Vue {
  @Prop()
  box!: IFlexMessageBox

  @Prop()
  selectedNode!: IFlexMessageCarousel | IFlexMessageBubble | IFlexMessageBox | IFlexMessageButton | IFlexMessageFiller | IFlexMessageIcon | IFlexMessageImage | IFlexMessageSeparator | IFlexMessageSpan | IFlexMessageText | IFlexMessageVideo

  @Prop()
  selectedPath!: string

  @Prop()
  parentPath!: string

  @Prop()
  errorPath!: string[]

  showChild = true

  isHover = false

  selectNode(node, path) {
    if (this.selectedNode === node && this.selectedPath === path) {
      this.$emit('onSelectNode', undefined, '')
    } else {
      this.$emit('onSelectNode', node, path)
    }
  }

  @Watch('isHover')
  onHover() {
    if (this.isHover) {
      this.$emit('onHoverNode', this.parentPath + 'box')
    }
  }

  beforeCreate() {
    this.$options.components!.FlexMessageTreeNodes = require('@/components/common/flex-message/FlexMessageTreeNodes.vue').default
  }
}
</script>

<style scoped lang="scss">

</style>
